<div class="academic-games-picker">
  <button class="back-btn" (click)="goBack()" [attr.aria-label]="currLang === 'ar' ? 'رجوع' : 'Back'">
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
      <path d="M19 12H5M5 12L12 19M5 12L12 5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  </button>

  <h2 class="picker-title">{{ 'game-mode.subjects.' + subjectKey | translate }}</h2>

  <div class="fun-grid" *ngIf="games.length > 0">
    <button class="fun-card" type="button" *ngFor="let game of games" (click)="play(game)">
      <div class="fun-icon" aria-hidden="true">{{ game.icon }}</div>
      <div class="fun-name">{{ currLang === 'ar' ? game.name.ar : game.name.en }}</div>
      <div class="fun-sub">{{ currLang === 'ar' ? game.sub.ar : game.sub.en }}</div>
    </button>
  </div>

  <div class="empty-state" *ngIf="games.length === 0">
    <div class="empty-icon" aria-hidden="true">✨</div>
    <div class="empty-title">{{ currLang === 'ar' ? 'ألعاب هذه المادة قريبًا' : 'Games for this subject are coming soon' }}</div>
  </div>
</div>
